module.exports = __webpack_public_path__ + "static/media/breadCrumbArrow.64a93c5a.svg";